import { defineMessages } from 'react-intl';

export default defineMessages({
  tituloGrafico: {
    id: 'PresupuestosGraficoTiempoResolucion.tituloGrafico',
    description: 'Título para el gráfico',
    defaultMessage: 'Tiempo de Resolución',
  },
});
